export default __webpack_public_path__ + "static/media/image-blogr.ac304141.jpg";